<!--
	NodeIndenter.svelte
-->

<script>
    export let level;
</script>

<style>
    :global(.node-indent) {
        /* background-color: #aaaaaa; */
    }
    .level-0 {
        width: 0px;
    }
    .level-1 {
        width: 30px;
    }
    .level-2 {
        width: 60px;
    }
    .level-3 {
        width: 90px;
    }
    .level-4 {
        width: 120px;
    }
    .level-5 {
        width: 150px;
    }
    
</style>

<div class={"node-indent level-" + level}>
</div>
